import createRefundTabBody from './_waitFirstAudit'
import {ZdsRefundTabStatus} from "@/pages/refund/config";

console.warn = () => {}
export default {
  noHeader: true,

  body: {
    type: 'page-tabs',
    default: ZdsRefundTabStatus.ALL,
    items: [
      { label: '全部', value: ZdsRefundTabStatus.ALL, body: { ...createRefundTabBody(ZdsRefundTabStatus.ALL) } },
      { label: '待一审', value: ZdsRefundTabStatus.DYS, body: {...createRefundTabBody(ZdsRefundTabStatus.DYS)} },
      { label: '待商家处理', value: ZdsRefundTabStatus.DSJCL, body: {...createRefundTabBody(ZdsRefundTabStatus.DMJCL)} },
      { label: '待买家处理', value: ZdsRefundTabStatus.DMJCL, body: {...createRefundTabBody(ZdsRefundTabStatus.DSJCL)} },
      { label: '历史记录', value: ZdsRefundTabStatus.LS, body:{...createRefundTabBody(ZdsRefundTabStatus.LS)} },
    ]
  }
}
